import { render, staticRenderFns } from "./SchoolPlansReport.vue?vue&type=template&id=5bc26e2f"
import script from "./SchoolPlansReport.vue?vue&type=script&lang=js"
export * from "./SchoolPlansReport.vue?vue&type=script&lang=js"
import style0 from "./SchoolPlansReport.vue?vue&type=style&index=0&id=5bc26e2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports